import React, { useState, useEffect, useCallback, useMemo } from 'react';
import ReactDOM from 'react-dom'; 
import socketService from '../services/socketService'; 
import Layout from '../components/Layout'; 
import { useNavigate } from 'react-router-dom';

// --- Seen Status Update Modal ---
const SeenUpdateModal = ({ log, onClose, fetchLogs }) => {
    const [operatorName, setOperatorName] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (!operatorName.trim()) return alert("অপারেটরের নাম লিখুন!");
        
        setLoading(true);
        const masterKey = localStorage.getItem('masterKey');
        socketService.emit('updateAppLogSeen', { 
            logId: log._id, 
            seenBy: operatorName,
            masterKey: masterKey
        });
    };

    useEffect(() => {
        const handleResponse = (data) => {
            if (data.success) {
                setLoading(false);
                fetchLogs(); 
                onClose();   
            } else {
                alert("Error: " + data.message);
                setLoading(false);
            }
        };
        socketService.on('appLogSeenUpdated', handleResponse);
        return () => socketService.off('appLogSeenUpdated', handleResponse);
    }, [fetchLogs, onClose]);

    if (!log) return null;

    const modalJSX = (
        <div 
            style={{ 
                position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
                backgroundColor: 'rgba(0,0,0,0.7)', backdropFilter: 'blur(4px)',
                zIndex: 10000, 
                display: 'flex', 
                alignItems: 'flex-start',
                justifyContent: 'center',
                paddingTop: '90px'
            }}
            onClick={onClose}
        >
            <div 
                className="modal-dialog" 
                style={{ width: '100%', maxWidth: '400px', pointerEvents: 'auto' }}
                onClick={(e) => e.stopPropagation()}
            >
                <div className="card shadow-lg border-0" style={{ borderRadius: '15px', background: '#fff' }}>
                    <div className="card-header bg-white border-0 pt-4 px-4 d-flex justify-content-between align-items-center">
                        <h6 style={{ fontWeight: '800', color: '#0d6efd', margin: 0 }}>✅ Mark as Seen</h6>
                        <button type="button" className="btn-close shadow-none" onClick={onClose}></button>
                    </div>
                    <div className="card-body p-4">
                        <form onSubmit={handleSubmit}>
                            <div className="mb-4">
                                <label style={{ fontSize: '11px', fontWeight: '800', color: '#64748b', display: 'block', marginBottom: '8px' }}>
                                    OPERATOR NAME / SEEN BY
                                </label>
                                <input 
                                    type="text" 
                                    className="form-control shadow-none" 
                                    placeholder="Enter your name..." 
                                    value={operatorName} 
                                    onChange={(e) => setOperatorName(e.target.value)}
                                    required
                                    autoFocus
                                    style={{ padding: '12px', borderRadius: '10px', border: '2px solid #f1f5f9', background: '#f8fafc' }}
                                />
                            </div>
                            <div className="d-flex gap-2">
                                <button type="submit" className="btn btn-primary w-100 py-2" disabled={loading} style={{ borderRadius: '10px', fontWeight: '700' }}>
                                    {loading ? 'Updating...' : 'Confirm Seen'}
                                </button>
                                <button type="button" className="btn btn-light border px-4" onClick={onClose} style={{ borderRadius: '10px' }}>
                                    Cancel
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );

    return ReactDOM.createPortal(modalJSX, document.body);
};

// --- Main AppReceiveUser Component ---
const AppReceiveUser = () => {
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(window.location.search);
    const usernameFromUrl = queryParams.get('username') || '';

    const [users, setUsers] = useState([]);
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(false);
    const [totalLogs, setTotalLogs] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(100);
    const [logToSeen, setLogToSeen] = useState(null);

    const [filters, setFilters] = useState({
        startDate: '', endDate: '', senderID: '', seenBy: '', 
        trxID: '', last3Digits: '', amount: '', username: usernameFromUrl
    });

    useEffect(() => {
        if (!socketService.connected) socketService.connect();
        socketService.emit('get_all_users'); 
        const handleUsers = (data) => setUsers(data || []);
        socketService.on('receive_all_users', handleUsers);
        return () => socketService.off('receive_all_users', handleUsers);
    }, []);

   /* const extractAmountNumber = (message) => {
        const regex = /Amount:\s*(?:৳|Tk\.?)?\s*([\d,.]+)(?:\s*Tk\.)?/i;
        const match = message.match(regex);
        if (match) {
            return parseFloat(match[1].replace(/,/g, '')) || 0;
        }
        return 0;
    };

    const extractAmountText = (message) => {
        const amt = extractAmountNumber(message);
        return amt > 0 ? `${amt.toLocaleString()} Tk.` : 'N/A';
    };
    */

    const extractAmountNumber = (message) => {
        if (!message) return 0;
        const text = String(message);
        
        // Ekhane 'deposite', 'deposit', 'rcv', 'rcvd' add kora hoyeche
        const regex = /(?:Amount|received|rcv|rcvd|Cash In|Payment|Remittance|deposit|deposite)[^\d]*(?:Tk\.?|৳|BDT)?[^\d]*([\d,]+\.\d+|[\d,]+)/i;
        let match = text.match(regex);
        
        // Jodi uporer word gulo na thake, tobe shudhu Tk, ৳ ba BDT er porer sonkha dhorbe
        if (!match) {
            const fallbackRegex = /(?:Tk\.?|BDT|৳)[^\d]*([\d,]+\.\d+|[\d,]+)/i;
            match = text.match(fallbackRegex);
        }
        
        if (match && match[1]) {
            return parseFloat(match[1].replace(/,/g, '')) || 0;
        }
        return 0;
    };


    const extractAmountText = (message) => {

        const amt = extractAmountNumber(message);

        return amt > 0 ? `৳ ${amt.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : 'N/A';

    };


    const totalAmountSum = useMemo(() => {
        if (logs.length === 0) return 0;
        return logs.reduce((sum, log) => {
            return sum + extractAmountNumber(log.message);
        }, 0);
    }, [logs]);


    const isSearchValid = useMemo(() => {
        const { trxID, last3Digits, amount, seenBy } = filters;

        // ১. TrxID ভ্যালিডেশন (কমপক্ষে ৮ অক্ষর হতে হবে)
        const isTrxValid = trxID && trxID.trim().length >= 8;

        // ২. লাস্ট ৩ ডিজিট এবং অ্যামাউন্ট (দুইটাই থাকতে হবে)
        const isNumberAmountValid = last3Digits && amount;

        // ৩. Seen By ভ্যালিডেশন (অপারেটরের নাম থাকতে হবে এবং 'unseen' হওয়া যাবে না)
        const isSeenByValid = seenBy && 
                              seenBy.trim().length > 0 && 
                              seenBy.trim().toLowerCase() !== 'unseen';

        // এখন এই ৩টার যেকোনো একটি সত্য হলে তবেই ডাটা আনবে
        return !!(isTrxValid || isNumberAmountValid || isSeenByValid);
    }, [filters]);


    const formatDate = (dateStr) => {
        const date = new Date(dateStr);
        return `${date.getDate()} ${date.toLocaleString('en-US', { month: 'short' })}, ${date.getFullYear()}`;
    };

    const formatTime = (dateStr) => {
        return new Date(dateStr).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });
    };

    const fetchLogs = useCallback(() => {
        if (filters.trxID && filters.trxID.trim().length < 8) {
            alert("TrxID অবশ্যই কমপক্ষে ৮ অক্ষরের হতে হবে!");
            return;
        }
        if (filters.last3Digits && !filters.amount) {
            alert("লাস্ট ৩ ডিজিট দিলে অবশ্যই Amount দিতে হবে!");
            return;
        }
        if (!isSearchValid) {
            setLogs([]); setTotalLogs(0); return;
        }

        setLoading(true);
        socketService.emit('fetchAppLogsUser', { ...filters, page: currentPage, limit: itemsPerPage }); 
    }, [filters, currentPage, itemsPerPage, isSearchValid]);

    useEffect(() => {
        if (!socketService.connected) socketService.connect();
        const handleLogsList = (data) => {
            if (data.success) {
                setLogs(data.logs || []);
                setTotalLogs(data.totalLogs || 0);
            } else {
                setLogs([]);
            }
            setLoading(false);
        };
        socketService.on('appLogsListUser', handleLogsList);
        if (isSearchValid) fetchLogs();
        else { setLogs([]); setTotalLogs(0); }
        return () => socketService.off('appLogsListUser', handleLogsList);
    }, [fetchLogs, isSearchValid]);

    const totalPages = Math.ceil(totalLogs / itemsPerPage);

    const renderPageNumbers = () => {
        const pageNumbers = [];
        let startPage = Math.max(1, currentPage - 2);
        let endPage = Math.min(totalPages, startPage + 4);
        if (endPage - startPage < 4) startPage = Math.max(1, endPage - 4);
        for (let i = startPage; i <= endPage; i++) {
            if (i > 0) pageNumbers.push(
                <button key={i} className={`page-btn ${currentPage === i ? 'active' : ''}`} onClick={() => setCurrentPage(i)}>{i}</button>
            );
        }
        return pageNumbers;
    };

    return (
        <Layout>
     <style>{`
    .main-content-area { background-color: #f4f7fa; min-height: 100vh; padding: 20px; width: 100%; }
    
    /* 🔥 UPDATED TAB STYLES (Clean Text + Border Stroke) */
    .nav-tabs-container { 
        display: flex; 
        background: #ffffff; /* সাদা ব্যাকগ্রাউন্ড */
        padding: 15px 20px 0 20px; 
        border-bottom: 1px solid #e2e8f0; 
        margin-bottom: 20px; 
        gap: 15px; 
    }
    
    .nav-tab-item { 
        padding: 10px 25px; 
        font-size: 13px; 
        font-weight: 600; 
        color: #64748b; 
        cursor: pointer; 
        border: 1px solid transparent; 
        border-radius: 6px; 
        transition: all 0.2s ease; 
        text-transform: uppercase; 
        margin-bottom: 15px; 
    }

    .nav-tab-item:hover { 
        color: #0d6efd; 
        background: #f8fafc;
    }

    /* 🔥 একটিভ ট্যাবে "Side Stock" (বর্ডার) */
    .nav-tab-item.active { 
        color: #0d6efd; 
        border: 1px solid #0d6efd; /* ✅ চারপাশে নীল বর্ডার */
        background: #f0f9ff;       /* হালকা নীল ব্যাকগ্রাউন্ড */
        font-weight: 800; 
    }

    /* 🔥 Payment Send এর মতো Count Badge স্টাইল */
    .count-badge { background: #fff; padding: 5px 15px; border-radius: 50px; border: 1px solid #e2e8f0; font-size: 13px; font-weight: 600; }
    .count-badge span { color: #0d6efd; font-weight: 800; }

    .section-title { color: #0d6efd; font-weight: 700; }
    .filter-card { background: #ffffff; padding: 20px; border-radius: 12px; box-shadow: 0 1px 10px rgba(0,0,0,0.05); margin-bottom: 20px; }
    .modern-input { background: #f8fafc; border: 1px solid #cbd5e1; padding: 10px 12px; border-radius: 8px; font-size: 13px; width: 100%; outline: none; transition: 0.2s; }
    .modern-input:focus { border-color: #0d6efd; box-shadow: 0 0 0 2px rgba(13,110,253,0.1); }
    .btn-apply { background: #0d6efd; color: white; border-radius: 8px; font-size: 13px; border: none; font-weight: 600; cursor: pointer; padding: 10px 20px; }
    .table-container { background: #ffffff; border-radius: 12px; overflow: hidden; box-shadow: 0 1px 3px rgba(0,0,0,0.05); min-height: 200px; display: flex; flex-direction: column; }
    .custom-zebra-table { width: 100%; border-collapse: collapse; }
    .custom-zebra-table th { background: #f1f5f9; padding: 15px; font-size: 11px; font-weight: 800; text-transform: uppercase; color: #475569; border-bottom: 2px solid #e2e8f0; }
    .custom-zebra-table td { padding: 15px; border-bottom: 1px solid #edf2f7; vertical-align: middle; }
    .status-unseen { background: #fff7ed; color: #ea580c; padding: 4px 12px; border-radius: 6px; font-size: 11px; font-weight: 700; border: 1px solid #ffedd5; cursor: pointer; }
    .status-seen { background: #f0fdf4; color: #16a34a; padding: 4px 12px; border-radius: 6px; font-size: 11px; font-weight: 700; border: 1px solid #bbf7d0; display: inline-block; cursor: not-allowed; opacity: 0.8; }
    .pagination-footer { display: flex; justify-content: flex-end; padding: 20px; background: #fff; border-top: 1px solid #f1f5f9; gap: 5px; margin-top: auto; }
    .page-btn { min-width: 35px; height: 35px; border-radius: 6px; border: 1px solid #dee2e6; background: #fff; cursor: pointer; }
    .page-btn.active { background: #0d6efd; color: #fff; border-color: #0d6efd; }
    .empty-state { padding: 60px; text-align: center; color: #94a3b8; font-weight: 500; }
`}</style>

            <div className="main-content-area">
                
                {/* 🔥 TAB SYSTEM HEADER */}
                <div className="bg-white rounded-top shadow-sm mb-4">
                    <div className="nav-tabs-container mb-0">
                        <div 
                            className="nav-tab-item"
                            onClick={() => usernameFromUrl && navigate(`/payment_send?username=${usernameFromUrl}`)}
                        >
                            📤 Payment Send
                        </div>
                        <div 
                            className="nav-tab-item active"
                            onClick={() => {}} 
                        >
                            📥 App Receive
                        </div>

                        <div 
                                className="nav-tab-item"
                                onClick={() => navigate(`/user_devices?username=${usernameFromUrl}`)}
                            >
                                📱 User Devices
                            </div>
                            <div 
                                className="nav-tab-item"
                                onClick={() => navigate(`/user_mobile_banking?username=${usernameFromUrl}`)}
                            >
                                💳 Mobile banking 
                            </div>

                                                       <div 
    className="nav-tab-item"
    // ✅ ফিক্স: এখানে user_devices এর পরিবর্তে api_keys হবে
    onClick={() => navigate(`/api_keys?username=${usernameFromUrl}`)}
>
    ⚙️ WD api config 
</div>
                       
                    </div>

                    <div className="d-flex justify-content-between align-items-center p-3">
                        <h4 className="section-title mb-0" style={{fontSize: '18px'}}>
                            App Receive : <span className="text-dark">{usernameFromUrl || 'Unknown'}</span>
                        </h4>

                        <div className="d-flex gap-2">
                            {/* 🔥 Logs Count Badge */}
                            <div className="count-badge">
                                Logs: <span>{totalLogs}</span>
                            </div>

                            {/* 🔥 Success Sum Badge (PaymentSend Style) */}
                            <div className="count-badge" style={{ borderColor: '#16a34a', background: '#f0fdf4' }}>
                                Success Sum: <span style={{ color: '#ff0000ff', fontSize: '18px' }}>
                                    ৳{totalAmountSum.toLocaleString()}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="filter-card">
                    <form onSubmit={(e) => { e.preventDefault(); setCurrentPage(1); fetchLogs(); }} className="row g-3 align-items-end">
                        <div className="col-md-2">
                            <label style={{ fontSize: '11px', fontWeight: '700', color: '#64748b' }}>START DATE</label>
                            <input type="date" className="modern-input" value={filters.startDate} onChange={(e)=>setFilters({...filters, startDate: e.target.value})} />
                        </div>
                        <div className="col-md-2">
                            <label style={{ fontSize: '11px', fontWeight: '700', color: '#64748b' }}>END DATE</label>
                            <input type="date" className="modern-input" value={filters.endDate} onChange={(e)=>setFilters({...filters, endDate: e.target.value})} />
                        </div>
                        <div className="col-md-2">
                            <label style={{ fontSize: '11px', fontWeight: '700', color: '#64748b' }}>TRX ID</label>
                            <input type="text" className="modern-input" placeholder="Min 8 chars..." value={filters.trxID} onChange={(e)=>setFilters({...filters, trxID: e.target.value})} />
                        </div>
                        <div className="col-md-2">
                            <label style={{ fontSize: '11px', fontWeight: '700', color: '#64748b' }}>LAST DIGITS</label>
                            <input type="text" className="modern-input" placeholder="Number end..." value={filters.last3Digits} onChange={(e)=>setFilters({...filters, last3Digits: e.target.value})} />
                        </div>
                        <div className="col-md-2">
                            <label style={{ fontSize: '11px', fontWeight: '700', color: '#64748b' }}>AMOUNT</label>
                            <input type="text" className="modern-input" placeholder="Amount..." value={filters.amount} onChange={(e)=>setFilters({...filters, amount: e.target.value})} />
                        </div>
                        <div className="col-md-2">
                            <label style={{ fontSize: '11px', fontWeight: '700', color: '#64748b' }}>SEEN BY</label>
                            <input type="text" className="modern-input" placeholder="Operator..." value={filters.seenBy} onChange={(e)=>setFilters({...filters, seenBy: e.target.value})} />
                        </div>
                        <div className="col-md-12 mt-3 d-flex gap-2 justify-content-end">
                            <button type="submit" className="btn-apply px-5">Search</button>
                            <button type="button" onClick={() => { setFilters({startDate: '', endDate: '', senderID: '', seenBy: '', trxID: '', last3Digits: '', amount: '', username: usernameFromUrl}); setCurrentPage(1); }} className="btn btn-light border px-4">Reset</button>
                        </div>
                    </form>
                </div>

                <div className="table-container shadow-sm">
                    {isSearchValid ? (
                        <>
                            <div className="table-responsive">
                                <table className="custom-zebra-table">
                                    <thead>
                                        <tr>
                                            <th>SIM & SENDER</th>
                                            <th>AMOUNT & DEVICE</th>
                                            <th>MESSAGE CONTENT</th>
                                            <th>DATE & TIME</th>
                                            <th>STATUS</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {!loading && logs.map((log) => (
                                            <tr key={log._id}>
                                                <td>
                                                    <b style={{ fontSize: '13px', display: 'block' }}>{log.simno}</b>
                                                    <span style={{ color: '#0d6efd', fontWeight: '700', fontSize: '12px' }}>{log.senderID}</span>
                                                </td>
                                                <td>
                                                    <b style={{ color: '#dc2626' }}>{extractAmountText(log.message)}</b>
                                                    <div style={{ fontSize: '11px', color: '#64748b' }}>{log.deviceName}</div>
                                                </td>
                                                <td style={{ fontSize: '13px', color: '#475569', maxWidth: '350px' }}>{log.message}</td>
                                                <td>
                                                    <div style={{ fontWeight: '700', fontSize: '13px' }}>{formatDate(log.receivedAt)}</div>
                                                    <div style={{ fontSize: '11px', color: '#64748b' }}>{formatTime(log.receivedAt)}</div>
                                                </td>
                                                <td>
                                                    {log.seenBy && log.seenBy !== 'unseen' && log.seenBy !== '' ? (
                                                        <span className="status-seen" title="Already seen, cannot edit">
                                                            Locked: {log.seenBy}
                                                        </span>
                                                    ) : (
                                                        <span className="status-unseen" onClick={() => setLogToSeen(log)}>
                                                            Mark Seen
                                                        </span>
                                                    )}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                {!loading && logs.length === 0 && (
                                    <div className="empty-state">No matching logs found.</div>
                                )}
                                {loading && (
                                    <div className="empty-state">Loading data...</div>
                                )}
                            </div>

                            <div className="pagination-footer">
                                <button className="page-btn" disabled={currentPage === 1} onClick={() => setCurrentPage(currentPage - 1)}>Prev</button>
                                {renderPageNumbers()}
                                <button className="page-btn" disabled={currentPage === totalPages || totalPages === 0} onClick={() => setCurrentPage(currentPage + 1)}>Next</button>
                            </div>
                        </>
                    ) : (
                        <div className="empty-state">
                             Enter a filter (TrxID or Number+Amount) to view logs.
                        </div>
                    )}
                </div>
            </div>

            <SeenUpdateModal 
                log={logToSeen} 
                onClose={() => setLogToSeen(null)} 
                fetchLogs={fetchLogs} 
            />
        </Layout>
    );
};

export default AppReceiveUser;